module.exports = __webpack_public_path__ + "576414a90af4ec7b89379ef69881aa91.svg";